/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React, {useCallback} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {GenericObject} from '@ion/core/src/types/entities';
import {FormItem} from '@ion/dls/src/components/forms/FormItem';
import {FormRadioGroup} from '@ion/dls/src/components/forms/FormRadioGroup';
import styles from '@ion/dls/src/editors/editorStyles';
import EmbeddedForm from '@ion/dls/src/editors/forms/EmbeddedForm';
import {useExtendStyles} from '@ion/dls/src/hooks/useExtendStyles';
import {BodyTypography} from '@ion/dls/src/typography/BodyTypography';
import {UseVBusStatusActionResult} from './useVBusStatusAction';

interface VBusStatusProps extends UseVBusStatusActionResult {
  id: number;
  path: string;
  action: GenericObject;
}

const useStyles = () => ({
  actionContainer : {
    paddingTop : '0px'
  }
});

export enum VBusAction {
  ON = 'Turn On',
  OFF = 'Turn Off'
}

const ACTION_OPTIONS = [{
  label    : VBusAction.ON,
  value    : VBusAction.ON,
  disabled : false
},
{
  label    : VBusAction.OFF,
  value    : VBusAction.OFF,
  disabled : false
}];

/**
 * The VBUS Status provides the UI which allows a user to turn on/off status...
 */
export const VBusStatus = ({
  id,
  path,
  updateAction,
  action
}: VBusStatusProps) => {
  const editorStyles = useExtendStyles(styles, useStyles);
  const classes      = editorStyles();
  const {status}     = action;

  const onActionChange = useCallback((value: string, name: string): void => {
    updateAction(name, value);
  }, []);

  return (
    <>
      <FormItem disableMinWidth customWidth={5}>
        <div className={classes.actionContainer}>
          <FormRadioGroup displayAsRow required
            options={ACTION_OPTIONS}
            name={'action'}
            key={`action_${id}`}
            groupLabel={translate(`${path}.label`)}
            onChange={onActionChange}
            defaultValue={status} />
        </div>
      </FormItem>
      <EmbeddedForm>
        <BodyTypography variant={'body2'}>
          {translate('common:editors.bulkActions.vBus.noteMessage')}
        </BodyTypography>
        <BodyTypography variant={'body2'}>
          {translate('common:editors.bulkActions.vBus.safeMessage')}
        </BodyTypography>
      </EmbeddedForm>
    </>
  );
};

export default VBusStatus;
